import { render, staticRenderFns } from "./ml-menu-item.vue?vue&type=template&id=2262debc&scoped=true"
import script from "./ml-menu-item.vue?vue&type=script&setup=true&lang=js"
export * from "./ml-menu-item.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_css-loader@6.11.0_webpack@5.109.2_cssnano@5.1.15__txhfkviks3ummxta33hlcz7ciy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262debc",
  null
  
)

export default component.exports